import { TypeYoutubeVideoWithoutUnresolvableLinksResponse } from 'bb-contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import YoutubeVideo from '../../../siteBuilder/blocks/core/VideoYouTube/VideoYouTube'

const ContentfulYoutubeVideo = withContentful<TypeYoutubeVideoWithoutUnresolvableLinksResponse['fields']>(
  YoutubeVideo,
  {
    posterSrc: (props) => props.fields?.thumbnail?.fields?.file?.url,
  }
)

export default ContentfulYoutubeVideo
